import { withStyles } from '@material-ui/core';
import { getStopStatusList } from '../../../Utils';
const styles = (theme) => ({
  proStatus: {
    fontWeight: 500,
    paddingTop: 4,
    fontSize: theme.dispatchCardTextFontSize,
    display: 'flex',
    justifyContent: 'space-between',
    paddingRight: 8
  }
});
const joinArrayElements = (array) => {
  return array.join(', ')?.toUpperCase();
};

const CompletedStopStatus = ({ classes, stopData, staticClientStatusLists }) => {
  const proStatus = getStopStatusList(stopData, staticClientStatusLists);
  if (proStatus.length === 0) {
    return null;
  }
  const displayStatus = proStatus.slice(0, 3);
  const remainingCount = proStatus.length - displayStatus.length;
  return (
    <div className={classes.proStatus}>
      <div>{`${joinArrayElements(displayStatus)}${remainingCount > 0 ? '...' : ''}`}</div>
      {remainingCount > 0 && <div>{`+${remainingCount} more`}</div>}
    </div>
  );
};

export default withStyles(styles)(CompletedStopStatus);
